import { DashboardLayout } from "@/components/layouts/DashboardLayout";
import { ChatInterface } from "@/components/chat/ChatInterface";

export default function Chat() {
  return (
    <DashboardLayout>
      <div className="page-container">
        <ChatInterface />
      </div>
    </DashboardLayout>
  );
}